import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useAgencyInfo } from "context/agency";
import { useAgencyStripe } from "queries/subscriptions";
import { useState } from "react";
import { useUserInfo } from "context/user";

function AddCardModal({ agencyStripe, open, onclose, handleRefresh }) {
    const [agency, Update] = useAgencyInfo();
    const userEmail = useUserInfo()[3];
    const element = useElements();
    const [processing, setProcessing] = useState(false);
    const [stripeErr, setStripeErr] = useState();
    const stripe = useStripe();

    // Same "agency-stripe" resource name billing/.../Balance/index.js reads,
    // so saving/creating a card here refreshes that balance tab too.
    const saveCardMutation = useAgencyStripe();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setProcessing(true);
        var name = event.target.name.value;

        if (element == null) {
            return;
        }
        let paymentMethod = {};

        const source = await stripe.createSource(element.getElement(CardElement));
        paymentMethod = await stripe.createPaymentMethod({
            type: "card",
            card: element.getElement(CardElement),
        });

        // 4848 7150 5203 7927

        const payload = {
            name: name,
            email: userEmail,
            make_default: true,
            paymentMethod: paymentMethod?.paymentMethod,
            source_id: source?.source?.id,
            agency_id: agency._id,
        };
        
        if (paymentMethod.error) {
            setStripeErr(paymentMethod.error.message)
            setProcessing(false);
            // handleClose();
        } else {
            if (agencyStripe) {
                payload._id = agencyStripe._id
            }
            const { response } = await saveCardMutation.mutateAsync({ isUpdate: !!agencyStripe, payload })

            if (response) {
                handleRefresh()
                onclose()
            }
        }
    };
    return (
        <>
            {open &&
                <div className="modal-zz-confirm text-left"  >

                    <div className="scrollable-modal-content bg-white  rounded" style={{ position: "relative" }}>
                        <h2 className='text-black text-left font-14'>Add Card
                        </h2>
                        <span className='crossison' onClick={onclose}>X</span>
                        <SoftBox>
                            <SoftBox component="form" onSubmit={handleSubmit} role="form">
                                <SoftBox>
                                    <SoftTypography variant="button" sx={{ fontSize: "14px", fontWeight: "500" }} mb={2}>
                                        Card Number
                                    </SoftTypography>
                                    <CardElement />
                                    {stripeErr &&
                                        <small style={{ color: 'red' }}>{stripeErr}</small>
                                    }
                                </SoftBox>
                                <SoftBox mt={2}>
                                    <SoftTypography variant="button" sx={{ fontSize: "14px", fontWeight: "500" }} mb={2}>
                                        Name
                                    </SoftTypography>
                                    <SoftInput name="name" />
                                </SoftBox>
                                <SoftBox display="flex" justifyContent="flex-end">
                                    <SoftButton
                                        variant="outlined"
                                        color="error"
                                        type="button"
                                        sx={{ mt: 4, mb: 1 }}
                                        onClick={onclose}
                                    >
                                        close
                                    </SoftButton>
                                    <SoftButton
                                        variant="outlined"
                                        color="dark"
                                        type="submit"
                                        sx={{ mt: 4, mb: 1, ml: 1 }}
                                        loading={processing}
                                        disabled={processing}
                                    >
                                        {
                                            agencyStripe ?
                                                "Update"
                                                :
                                                "Add"
                                        }
                                    </SoftButton>
                                </SoftBox>
                            </SoftBox>
                        </SoftBox>
                    </div>
                </div>}
        </>
    );
}

export default AddCardModal;
